import { persistSettings } from "../../calendar-common/helpers/settingsHelper";
import { TIME_FORMAT_OPTIONS, TIMEZONE_VALUES } from "../constants";

const REGEX_EXPRESSION = /[^\d.+:-]/g;

const getTimezoneOffset = (offset) => {
    if (offset === "") return 0;

    var sign = /^-/.test(offset) ? 1 : -1;
    var [h, m] = offset.slice(-5).split(":");

    var result = sign * h * 60 + sign * m;
    return result;
};

const clockUpdateReceived = (store, time) => {
    store.setState({
        currentTime: time,
    });
};

const updateClockListener = (store) => {
    const { config } = store.getState();
    if (config.calendarUpdateClockEventName) {
        document.addEventListener(
            config.calendarUpdateClockEventName,
            function (e) {
                clockUpdateReceived(store, e.detail);
            },
            false
        );
    }
};
const clockUpdate = (store) => {
    store.setState({
        currentTime: new Date(),
    });
};
const updateClockAction = (store) => {
    var now = new Date();
    var delay = 60 * 1000;
    var start = delay - now.getUTCSeconds() * 1000 + now.getUTCMilliseconds();

    setTimeout(function () {
        setInterval(clockUpdate, delay, store);
        clockUpdate(store);
    }, start);

    // Added timeout to run after initTimezones
    setTimeout(function () {
        clockUpdate(store);
    }, 1000);
};

export const initTimezones = (store) => {
    const { config } = store.getState();

    if (!config.timezoneHelper) {
        getDefaultTimeZones(store);
        updateClockAction(store);
    } else {
        updateClockListener(store);
        config.timezoneHelper().then((helper) => {
            helper
                .getTimezonesModel()
                .then((timezonesModel) => {
                    timezonesModel.TimeZones.forEach((element) => {
                        if (element.TimeZoneId !== null)
                            element.OffsetValue = getTimezoneOffset(
                                element.TimeSpan.replace(REGEX_EXPRESSION, "")
                            );
                    });
                    if (timezonesModel.TimeZoneInfoId) {
                        timezonesModel.CurrentTimeZone =
                            timezonesModel.TimeZones.find(
                                (x) =>
                                    x.TimeZoneId ===
                                    timezonesModel.TimeZoneInfoId
                            );
                    } else if (
                        timezonesModel.CurrentTimeZone != null &&
                        timezonesModel.CurrentTimeZone.TimeZoneId != null
                    ) {
                        const offsetValue = getTimezoneOffset(
                            timezonesModel.CurrentTimeZone.TimeSpan.replace(
                                REGEX_EXPRESSION,
                                ""
                            )
                        );
                        timezonesModel.CurrentTimeZone.OffsetValue =
                            offsetValue;
                    } else {
                        const offsetValue = new Date().getTimezoneOffset();
                        timezonesModel.CurrentTimeZone =
                            timezonesModel.TimeZones.find(
                                (x) => x.OffsetValue === offsetValue
                            );
                    }

                    var timeFormat = timezonesModel.IsTwelveTimeFormat
                        ? TIME_FORMAT_OPTIONS.TwelveHours
                        : TIME_FORMAT_OPTIONS.TwentyFourHours;

                    store.setState({
                        timezones: timezonesModel.TimeZones,
                        currentTimezone: timezonesModel.CurrentTimeZone,
                        timezoneOffset:
                            timezonesModel.CurrentTimeZone.OffsetValue,
                        timeFormat: timeFormat,
                        automaticallyTimeZone:
                            timezonesModel.SetAutomaticallyTimeZone,
                        currentTime: new Date(),
                    });

                    const { settings } = store.getState();
                    settings.timezoneOffset =
                        timezonesModel.CurrentTimeZone.OffsetValue;
                    persistSettings(store, settings);
                })
                .catch((err) => {
                    console.error("Could not get timezones");
                    console.error(err);
                });
        });
    }
};

export const changeTimeFormat = (store, timeFormat) => {
    if (timeFormat != undefined) {
        store.setState(timeFormat);
        const isTwelveTimeFormat =
            Object.values(timeFormat)[0] == TIME_FORMAT_OPTIONS.TwelveHours;
        const { config } = store.getState();
        if (!config.timezoneHelper) return;

        config.timezoneHelper().then((helper) => {
            helper.setTimeFormat(isTwelveTimeFormat);
        });
    }
};

function getDefaultTimeZones(store) {
    var actualTime = new Date();
    var timeZoneOffset = actualTime.getTimezoneOffset();

    var currentTimezone = TIMEZONE_VALUES.find(
        (x) => x.OffsetValue === timeZoneOffset
    );
    store.setState({
        timezones: TIMEZONE_VALUES,
        currentTimezone: currentTimezone,
        timezoneOffset: timeZoneOffset,
        timeFormat: TIME_FORMAT_OPTIONS.TwentyFourHours,
        hasDefautTimezones: true,
    });

    const { settings } = store.getState();
    settings.timezoneOffset = timeZoneOffset;
    persistSettings(store, settings);
}
